import React from 'react';
const ThemeTypeContext = React.createContext({});
export const ThemeTypeProvider = ThemeTypeContext.Provider;
export function useThemeType() {
    const context = React.useContext(ThemeTypeContext);
    if (context === undefined) {
        throw new Error('useThemeType must be used within a ThemeTypeProvider');
    }
    return context.themeType;
}
